<script>
  import _ from 'underscore'
  import ItemPage from '../components/ItemPage.vue'
  import ItemList from '../components/ItemList.vue'
  import PageChooser from '../components/PageChooser.vue'
  import Status from '../components/Status.vue'
  import { item } from '../components/Item.vue'

  export default {
    components: { ItemPage, ItemList, PageChooser, Status },

    data () {
      return {
        date : '2020-03-20',
        major: [],
        excepts: [],
        items: [

          // [NOTE] ジュエルアイドルチャレンジセット～ミラクル☆キラッツ～
          // ================================================================================

          item({
            collection  : 'JICS_Kirats',
            id          : 'AM-117',
            rare        : 'SR',
            name        : 'ファンシーレースアップトップス',
            imgUrl      : '/images/items/AM-117.png',
            kind        : 'トップス',
            color       : '桃',
            brand       : 'SH',
            type        : 'LO',
            point       : 800,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JICS_Kirats',
            id          : 'AM-118',
            rare        : 'SR',
            name        : 'ファンシーレースアップスカート',
            imgUrl      : '/images/items/AM-118.png',
            kind        : 'ボトムス',
            color       : '桃',
            brand       : 'SH',
            type        : 'LO',
            point       : 750,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JICS_Kirats',
            id          : 'AM-119',
            rare        : 'SR',
            name        : 'ファンシーレースアップシューズ',
            imgUrl      : '/images/items/AM-119.png',
            kind        : 'シューズ',
            color       : '桃',
            brand       : 'SH',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JICS_Kirats',
            id          : 'AM-120',
            rare        : 'SR',
            name        : 'ファンシーレースアップヘアアクセ',
            imgUrl      : '/images/items/AM-120.png',
            kind        : 'ヘアアクセ',
            color       : '黄',
            brand       : 'SH',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'JICS_Kirats',
            id          : 'AM-121',
            rare        : 'R',
            name        : 'クラッシーブルーチェックブラウス',
            imgUrl      : '/images/items/AM-121.png',
            kind        : 'トップス',
            color       : '青',
            brand       : 'SA',
            type        : 'CO',
            point       : 600,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JICS_Kirats',
            id          : 'AM-122',
            rare        : 'R',
            name        : 'クラッシーブルーチェックスカート',
            imgUrl      : '/images/items/AM-122.png',
            kind        : 'ボトムス',
            color       : '青',
            brand       : 'SA',
            type        : 'CO',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JICS_Kirats',
            id          : 'AM-123',
            rare        : 'R',
            name        : 'クラッシーブルーチェックパンプス',
            imgUrl      : '/images/items/AM-123.png',
            kind        : 'シューズ',
            color       : '赤',
            brand       : 'SA',
            type        : 'CO',
            point       : 550,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JICS_Kirats',
            id          : 'AM-124',
            rare        : 'R',
            name        : 'クラッシーレッドヘアアクセ',
            imgUrl      : '/images/items/AM-124.png',
            kind        : 'ヘアアクセ',
            color       : '赤',
            brand       : 'SA',
            type        : 'CO',
            point       : 550,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'JICS_Kirats',
            id          : 'AM-125',
            rare        : 'SR',
            name        : 'イエローハートのシャボンだまセット',
            imgUrl      : '/images/items/AM-125.png',
            kind        : 'パシャッとアイテム',
            color       : '黄',
            brand       : 'GY',
            type        : 'PO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JICS_Kirats',
            rare        : 'SR',
            kind        : 'パシャッとアイテム',
          }),
          item({
            collection  : 'JICS_Kirats',
            rare        : 'SR',
            kind        : 'パシャッとアイテム',
          }),
          item({
            collection  : 'JICS_Kirats',
            rare        : 'SR',
            kind        : 'パシャッとアイテム',
          }),


          // [NOTE] ジュエルアイドルチャレンジセット～メルティックスター～
          // ================================================================================

          item({
            collection  : 'JICS_MelticStar',
            id          : 'AM-178',
            rare        : 'SR',
            name        : 'ローズガーデントップス',
            imgUrl      : '/images/items/AM-178.png',
            kind        : 'トップス',
            color       : '赤',
            brand       : 'DW',
            type        : 'LO',
            point       : 800,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JICS_MelticStar',
            id          : 'AM-179',
            rare        : 'SR',
            name        : 'ローズガーデンスカート',
            imgUrl      : '/images/items/AM-179.png',
            kind        : 'ボトムス',
            color       : '赤',
            brand       : 'DW',
            type        : 'LO',
            point       : 750,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JICS_MelticStar',
            id          : 'AM-180',
            rare        : 'SR',
            name        : 'ローズガーデンシューズ',
            imgUrl      : '/images/items/AM-180.png',
            kind        : 'シューズ',
            color       : '赤',
            brand       : 'DW',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JICS_MelticStar',
            id          : 'AM-181',
            rare        : 'SR',
            name        : 'ローズガーデンヘアアクセ',
            imgUrl      : '/images/items/AM-181.png',
            kind        : 'ヘアアクセ',
            color       : '赤',
            brand       : 'DW',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'JICS_MelticStar',
            id          : 'AM-182',
            rare        : 'SR',
            name        : 'サーカスリングマスターオレンジトップス',
            imgUrl      : '/images/items/AM-182.png',
            kind        : 'トップス',
            color       : '虹',
            brand       : 'UQ',
            type        : 'CO',
            point       : 750,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JICS_MelticStar',
            id          : 'AM-183',
            rare        : 'SR',
            name        : 'サーカスリングマスターオレンジスカート',
            imgUrl      : '/images/items/AM-183.png',
            kind        : 'ボトムス',
            color       : '虹',
            brand       : 'UQ',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JICS_MelticStar',
            id          : 'AM-184',
            rare        : 'SR',
            name        : 'サーカスリングマスターオレンジシューズ',
            imgUrl      : '/images/items/AM-184.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'UQ',
            type        : 'CO',
            point       : 800,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JICS_MelticStar',
            id          : 'AM-185',
            rare        : 'SR',
            name        : 'サーカスリングマスターオレンジヘアアクセ',
            imgUrl      : '/images/items/AM-185.png',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : 'UQ',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'JICS_MelticStar',
            id          : 'AM-186',
            rare        : 'R',
            name        : 'ビッグ☆グリーンパンダ',
            imgUrl      : '/images/items/AM-186.png',
            kind        : 'パシャッとアイテム',
            color       : '緑',
            brand       : 'RB',
            type        : 'CO',
            point       : 550,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JICS_MelticStar',
            rare        : 'R',
            kind        : 'パシャッとアイテム',
          }),
          item({
            collection  : 'JICS_MelticStar',
            rare        : 'R',
            kind        : 'パシャッとアイテム',
          }),
          item({
            collection  : 'JICS_MelticStar',
            rare        : 'R',
            kind        : 'パシャッとアイテム',
          }),


          // [NOTE] ジュエルアイドルチャレンジセット～リングマリィ～
          // ================================================================================

          item({
            collection  : 'JICS_RingMarry',
            id          : 'AM-188',
            rare        : 'SR',
            name        : 'グルーヴィダンサブルトップス',
            imgUrl      : '/images/items/AM-188.png',
            kind        : 'トップス',
            color       : '緑',
            brand       : 'DS',
            type        : 'CO',
            point       : 800,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JICS_RingMarry',
            id          : 'AM-189',
            rare        : 'SR',
            name        : 'グルーヴィダンサブルスカート',
            imgUrl      : '/images/items/AM-189.png',
            kind        : 'ボトムス',
            color       : '黒',
            brand       : 'DS',
            type        : 'CO',
            point       : 750,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JICS_RingMarry',
            id          : 'AM-190',
            rare        : 'SR',
            name        : 'グルーヴィダンサブルシューズ',
            imgUrl      : '/images/items/AM-190.png',
            kind        : 'シューズ',
            color       : '桃',
            brand       : 'DS',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JICS_RingMarry',
            id          : 'AM-191',
            rare        : 'SR',
            name        : 'グルーヴィダンサブルヘアアクセ',
            imgUrl      : '/images/items/AM-191.png',
            kind        : 'ヘアアクセ',
            color       : '緑',
            brand       : 'DS',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'JICS_RingMarry',
            id          : 'AM-192',
            rare        : 'SR',
            name        : 'クローバーファンタジーオレンジトップス',
            imgUrl      : '/images/items/AM-192.png',
            kind        : 'トップス',
            color       : '虹',
            brand       : 'CH',
            type        : 'LO',
            point       : 750,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JICS_RingMarry',
            id          : 'AM-193',
            rare        : 'SR',
            name        : 'クローバーファンタジーオレンジスカート',
            imgUrl      : '/images/items/AM-193.png',
            kind        : 'ボトムス',
            color       : '虹',
            brand       : 'CH',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JICS_RingMarry',
            id          : 'AM-194',
            rare        : 'SR',
            name        : 'クローバーファンタジーオレンジシューズ',
            imgUrl      : '/images/items/AM-194.png',
            kind        : 'シューズ',
            color       : '桃',
            brand       : 'CH',
            type        : 'LO',
            point       : 800,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JICS_RingMarry',
            id          : 'AM-195',
            rare        : 'SR',
            name        : 'クローバーファンタジーオレンジヘアアクセ',
            imgUrl      : '/images/items/AM-195.png',
            kind        : 'ヘアアクセ',
            color       : '虹',
            brand       : 'CH',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'JICS_RingMarry',
            id          : 'AM-196',
            rare        : 'R',
            name        : 'ピンキーみずでっぽう',
            imgUrl      : '/images/items/AM-196.png',
            kind        : 'パシャッとアイテム',
            color       : '桃',
            brand       : 'DS',
            type        : 'CO',
            point       : 550,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JICS_RingMarry',
            rare        : 'R',
            kind        : 'パシャッとアイテム',
          }),
          item({
            collection  : 'JICS_RingMarry',
            rare        : 'R',
            kind        : 'パシャッとアイテム',
          }),
          item({
            collection  : 'JICS_RingMarry',
            rare        : 'R',
            kind        : 'パシャッとアイテム',
          }),


          // [NOTE] ジュエルアイドルチャレンジセット～だいあ＆アンジュ～
          // ================================================================================

          item({
            collection  : 'JICS_Dia_Ange',
            id          : 'AM-341',
            rare        : 'SR',
            name        : 'ふわもこスノートップス',
            imgUrl      : '/images/items/AM-341.png',
            kind        : 'トップス',
            color       : '白',
            brand       : 'MR',
            type        : 'PO',
            point       : 800,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JICS_Dia_Ange',
            id          : 'AM-342',
            rare        : 'SR',
            name        : 'ふわもこスノースカート',
            imgUrl      : '/images/items/AM-342.png',
            kind        : 'ボトムス',
            color       : '水',
            brand       : 'MR',
            type        : 'PO',
            point       : 750,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JICS_Dia_Ange',
            id          : 'AM-343',
            rare        : 'SR',
            name        : 'ふわもこスノーシューズ',
            imgUrl      : '/images/items/AM-343.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'MR',
            type        : 'PO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JICS_Dia_Ange',
            id          : 'AM-344',
            rare        : 'SR',
            name        : 'ふわもこスノーヘアアクセ',
            imgUrl      : '/images/items/AM-344.png',
            kind        : 'ヘアアクセ',
            color       : '水',
            brand       : 'MR',
            type        : 'PO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'JICS_Dia_Ange',
            id          : 'AM-345',
            rare        : 'SR',
            name        : 'ピーコックビューティートップス',
            imgUrl      : '/images/items/AM-345.png',
            kind        : 'トップス',
            color       : '緑',
            brand       : 'PM',
            type        : 'PR',
            point       : 750,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JICS_Dia_Ange',
            id          : 'AM-346',
            rare        : 'SR',
            name        : 'ピーコックビューティースカート',
            imgUrl      : '/images/items/AM-346.png',
            kind        : 'ボトムス',
            color       : '緑',
            brand       : 'PM',
            type        : 'PR',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JICS_Dia_Ange',
            id          : 'AM-347',
            rare        : 'SR',
            name        : 'ピーコックビューティーシューズ',
            imgUrl      : '/images/items/AM-347.png',
            kind        : 'シューズ',
            color       : '緑',
            brand       : 'PM',
            type        : 'PR',
            point       : 800,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JICS_Dia_Ange',
            id          : 'AM-348',
            rare        : 'SR',
            name        : 'ピーコックビューティーヘアアクセ',
            imgUrl      : '/images/items/AM-348.png',
            kind        : 'ヘアアクセ',
            color       : '緑',
            brand       : 'PM',
            type        : 'PR',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'JICS_Dia_Ange',
            id          : 'AM-349',
            rare        : 'R',
            name        : 'レインボータピオカ',
            imgUrl      : '/images/items/AM-349.png',
            kind        : 'パシャッとアイテム',
            color       : '虹',
            brand       : 'MR',
            type        : 'PO',
            point       : 550,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'JICS_Dia_Ange',
            rare        : 'R',
            kind        : 'パシャッとアイテム',
          }),
          item({
            collection  : 'JICS_Dia_Ange',
            rare        : 'R',
            kind        : 'パシャッとアイテム',
          }),
          item({
            collection  : 'JICS_Dia_Ange',
            rare        : 'R',
            kind        : 'パシャッとアイテム',
          }),


          // [NOTE] プリ☆チャン キラッとスペシャル！ファイル＆コーデDXセット
          // ================================================================================

          item({
            collection  : 'FileCoordDXSet1',
            id          : 'AM-209',
            rare        : 'SR',
            name        : 'エンジェルナースレッドトップス',
            imgUrl      : '/images/items/AM-209.png',
            kind        : 'トップス',
            color       : '赤',
            brand       : 'SH',
            type        : 'LO',
            point       : 800,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'FileCoordDXSet1',
            id          : 'AM-210',
            rare        : 'SR',
            name        : 'エンジェルナースレッドスカート',
            imgUrl      : '/images/items/AM-210.png',
            kind        : 'ボトムス',
            color       : '赤',
            brand       : 'SH',
            type        : 'LO',
            point       : 750,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'FileCoordDXSet1',
            id          : 'AM-211',
            rare        : 'SR',
            name        : 'エンジェルナースレッドシューズ',
            imgUrl      : '/images/items/AM-211.png',
            kind        : 'シューズ',
            color       : '赤',
            brand       : 'SH',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'FileCoordDXSet1',
            id          : 'AM-212',
            rare        : 'SR',
            name        : 'エンジェルナースレッドヘアアクセ',
            imgUrl      : '/images/items/AM-212.png',
            kind        : 'ヘアアクセ',
            color       : '赤',
            brand       : 'SH',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'FileCoordDXSet1',
            id          : 'AM-201',
            rare        : 'SR',
            name        : 'サーカスピエロイエロートップス',
            imgUrl      : '/images/items/AM-201.png',
            kind        : 'トップス',
            color       : '黄',
            brand       : 'GY',
            type        : 'PO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'FileCoordDXSet1',
            id          : 'AM-202',
            rare        : 'SR',
            name        : 'サーカスピエロイエローパンツ',
            imgUrl      : '/images/items/AM-202.png',
            kind        : 'ボトムス',
            color       : '黄',
            brand       : 'GY',
            type        : 'PO',
            point       : 800,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'FileCoordDXSet1',
            id          : 'AM-203',
            rare        : 'SR',
            name        : 'サーカスピエロイエローシューズ',
            imgUrl      : '/images/items/AM-203.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'GY',
            type        : 'PO',
            point       : 750,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'FileCoordDXSet1',
            id          : 'AM-204',
            rare        : 'SR',
            name        : 'サーカスピエロイエローヘアアクセ',
            imgUrl      : '/images/items/AM-204.png',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : 'GY',
            type        : 'PO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'FileCoordDXSet1',
            id          : 'AM-205',
            rare        : 'SR',
            name        : 'サーカスリングマスターブルートップス',
            imgUrl      : '/images/items/AM-205.png',
            kind        : 'トップス',
            color       : '青',
            brand       : 'SA',
            type        : 'CO',
            point       : 750,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'FileCoordDXSet1',
            id          : 'AM-206',
            rare        : 'SR',
            name        : 'サーカスリングマスターブル－スカート',
            imgUrl      : '/images/items/AM-206.png',
            kind        : 'ボトムス',
            color       : '青',
            brand       : 'SA',
            type        : 'CO',
            point       : 800,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'FileCoordDXSet1',
            id          : 'AM-207',
            rare        : 'SR',
            name        : 'サーカスリングマスターブルーシューズ',
            imgUrl      : '/images/items/AM-207.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'SA',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'FileCoordDXSet1',
            id          : 'AM-208',
            rare        : 'SR',
            name        : 'サーカスリングマスターブルーヘアアクセ',
            imgUrl      : '/images/items/AM-208.png',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : 'SA',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'FileCoordDXSet1',
            id          : 'AM-197',
            rare        : 'SR',
            name        : 'かいがらゆかたビビッドピンクトップス',
            imgUrl      : '/images/items/AM-197.png',
            kind        : 'トップス',
            color       : '桃',
            brand       : 'DW',
            type        : 'LO',
            point       : 800,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'FileCoordDXSet1',
            id          : 'AM-198',
            rare        : 'SR',
            name        : 'かいがらゆかたビビッドピンクスカート',
            imgUrl      : '/images/items/AM-198.png',
            kind        : 'ボトムス',
            color       : '桃',
            brand       : 'DW',
            type        : 'LO',
            point       : 750,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'FileCoordDXSet1',
            id          : 'AM-199',
            rare        : 'SR',
            name        : 'かいがらゆかたビビッドピンクシューズ',
            imgUrl      : '/images/items/AM-199.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'DW',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'FileCoordDXSet1',
            id          : 'AM-200',
            rare        : 'SR',
            name        : 'かいがらゆかたビビッドピンクヘアアクセ',
            imgUrl      : '/images/items/AM-200.png',
            kind        : 'ヘアアクセ',
            color       : '桃',
            brand       : 'DW',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'FileCoordDXSet1',
            id          : 'AM-213',
            rare        : 'SR',
            name        : 'ミラクルアイドルグリーントップス',
            imgUrl      : '/images/items/AM-213.png',
            kind        : 'トップス',
            color       : '緑',
            brand       : 'RB',
            type        : 'CO',
            point       : 750,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'FileCoordDXSet1',
            id          : 'AM-214',
            rare        : 'SR',
            name        : 'ミラクルアイドルグリーンパンツ',
            imgUrl      : '/images/items/AM-214.png',
            kind        : 'ボトムス',
            color       : '緑',
            brand       : 'RB',
            type        : 'CO',
            point       : 800,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'FileCoordDXSet1',
            id          : 'AM-215',
            rare        : 'SR',
            name        : 'ミラクルアイドルグリーンシューズ',
            imgUrl      : '/images/items/AM-215.png',
            kind        : 'シューズ',
            color       : '緑',
            brand       : 'RB',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'FileCoordDXSet1',
            id          : 'AM-216',
            rare        : 'SR',
            name        : 'ミラクルアイドルグリーンヘアアクセ',
            imgUrl      : '/images/items/AM-216.png',
            kind        : 'ヘアアクセ',
            color       : '緑',
            brand       : 'RB',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'FileCoordDXSet1',
            id          : 'AM-217',
            rare        : 'SR',
            name        : 'ミラクルアイドルパープルトップス',
            imgUrl      : '/images/items/AM-217.png',
            kind        : 'トップス',
            color       : '紫',
            brand       : 'UQ',
            type        : 'CO',
            point       : 800,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'FileCoordDXSet1',
            id          : 'AM-218',
            rare        : 'SR',
            name        : 'ミラクルアイドルパープルスカート',
            imgUrl      : '/images/items/AM-218.png',
            kind        : 'ボトムス',
            color       : '紫',
            brand       : 'UQ',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'FileCoordDXSet1',
            id          : 'AM-219',
            rare        : 'SR',
            name        : 'ミラクルアイドルパープルシューズ',
            imgUrl      : '/images/items/AM-219.png',
            kind        : 'シューズ',
            color       : '紫',
            brand       : 'UQ',
            type        : 'CO',
            point       : 750,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'FileCoordDXSet1',
            id          : 'AM-220',
            rare        : 'SR',
            name        : 'ミラクルアイドルパープルヘアアクセ',
            imgUrl      : '/images/items/AM-220.png',
            kind        : 'ヘアアクセ',
            color       : '紫',
            brand       : 'UQ',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] プリ☆チャン キラッとスペシャル！ファイル＆コーデDXセット2
          // ================================================================================

          item({
            collection  : 'FileCoordDXSet2',
            id          : 'AM-332',
            rare        : 'SR',
            name        : 'ひまわりスマイルレッドトップス',
            imgUrl      : '/images/items/AM-332.png',
            kind        : 'トップス',
            color       : '黄',
            brand       : 'SH',
            type        : 'LO',
            point       : 800,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'FileCoordDXSet2',
            id          : 'AM-333',
            rare        : 'SR',
            name        : 'ひまわりスマイルレッドスカート',
            imgUrl      : '/images/items/AM-333.png',
            kind        : 'ボトムス',
            color       : '赤',
            brand       : 'SH',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'FileCoordDXSet2',
            id          : 'AM-334',
            rare        : 'SR',
            name        : 'ひまわりスマイルレッドシューズ',
            imgUrl      : '/images/items/AM-334.png',
            kind        : 'シューズ',
            color       : '黄',
            brand       : 'SH',
            type        : 'LO',
            point       : 750,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'FileCoordDXSet2',
            id          : 'AM-335',
            rare        : 'SR',
            name        : 'ひまわりスマイルレッドヘアアクセ',
            imgUrl      : '/images/items/AM-335.png',
            kind        : 'ヘアアクセ',
            color       : '黄',
            brand       : 'SH',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'FileCoordDXSet2',
            id          : 'AM-336',
            rare        : 'SR',
            name        : 'ジャンピンラビッツピンクトップス',
            imgUrl      : '/images/items/AM-336.png',
            kind        : 'トップス',
            color       : '黒',
            brand       : 'DS',
            type        : 'CO',
            point       : 800,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'FileCoordDXSet2',
            id          : 'AM-337',
            rare        : 'SR',
            name        : 'ジャンピンラビッツピンクパンツ',
            imgUrl      : '/images/items/AM-337.png',
            kind        : 'ボトムス',
            color       : '黒',
            brand       : 'DS',
            type        : 'CO',
            point       : 750,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'FileCoordDXSet2',
            id          : 'AM-338',
            rare        : 'SR',
            name        : 'ジャンピンラビッツピンクシューズ',
            imgUrl      : '/images/items/AM-338.png',
            kind        : 'シューズ',
            color       : '黒',
            brand       : 'DS',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'FileCoordDXSet2',
            id          : 'AM-339',
            rare        : 'SR',
            name        : 'ジャンピンラビッツピンクヘアアクセ',
            imgUrl      : '/images/items/AM-339.png',
            kind        : 'ヘアアクセ',
            color       : '黒',
            brand       : 'DS',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'FileCoordDXSet2',
            rare        : 'SR',
          }),
          item({
            collection  : 'FileCoordDXSet2',
            id          : 'AM-340',
            rare        : 'SR',
            name        : 'ジャンピンラビッツピンクスカート',
            imgUrl      : '/images/items/AM-340.png',
            kind        : 'ボトムス',
            color       : '黒',
            brand       : 'DS',
            type        : 'CO',
            point       : 750,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'FileCoordDXSet2',
            rare        : 'SR',
          }),
          item({
            collection  : 'FileCoordDXSet2',
            rare        : 'SR',
          }),


          // [NOTE] だいあとアンジュ ジュエル＆コーデセット
          // ================================================================================

          item({
            collection  : 'Dia_Ange_JewelCoordSet',
            id          : 'AM-275',
            rare        : 'SR',
            name        : 'シャイニースターブラックトップス',
            imgUrl      : '/images/items/AM-275.png',
            kind        : 'トップス',
            color       : '黒',
            brand       : 'PM',
            type        : 'PR',
            point       : 800,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Dia_Ange_JewelCoordSet',
            id          : 'AM-276',
            rare        : 'SR',
            name        : 'シャイニースターブラックスカート',
            imgUrl      : '/images/items/AM-276.png',
            kind        : 'ボトムス',
            color       : '黒',
            brand       : 'PM',
            type        : 'PR',
            point       : 750,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Dia_Ange_JewelCoordSet',
            id          : 'AM-277',
            rare        : 'SR',
            name        : 'シャイニースターブラックシューズ',
            imgUrl      : '/images/items/AM-277.png',
            kind        : 'シューズ',
            color       : '黒',
            brand       : 'PM',
            type        : 'PR',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Dia_Ange_JewelCoordSet',
            id          : 'AM-278',
            rare        : 'SR',
            name        : 'シャイニースターブラックヘアアクセ',
            imgUrl      : '/images/items/AM-278.png',
            kind        : 'ヘアアクセ',
            color       : '黒',
            brand       : 'PM',
            type        : 'PR',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),

        ]
      }
    },

    methods: {
      collection (collection = '', rare = '', isPashattoItem = false) {
        const items = rare
          ? _.where(this.items, { collection, rare })
          : _.where(this.items, { collection })
        return items.filter(item => isPashattoItem
            ? item.kind === 'パシャッとアイテム'
            : item.kind !== 'パシャッとアイテム'
        )
      },
    },
  }
</script>


<template>
  <ItemPage :items="items" :narrowCols="[]">

    <template #title>
      <PageChooser />
      <time>{{ date }}</time>
    </template>

    <template #col1>
      <ItemList title="ジュエルアイドルチャレンジセット|～ミラクル☆キラッツ～" color="#00c7da" :items="collection('JICS_Kirats', 'SR')" />
      <ItemList title="" color="#feab0d" :items="collection('JICS_Kirats', 'R')" />
      <ItemList title="" color="#00c7da" :items="collection('JICS_Kirats', 'SR', true)" />

      <ItemList title="ジュエルアイドルチャレンジセット|～メルティックスター～" color="#00c7da" :items="collection('JICS_MelticStar', 'SR')" />
      <ItemList title="" color="#feab0d" :items="collection('JICS_MelticStar', 'R', true)" />
    </template>

    <template #col2>
      <ItemList title="ジュエルアイドルチャレンジセット|～リングマリィ～" color="#00c7da" :items="collection('JICS_RingMarry', 'SR')" />
      <ItemList title="" color="#feab0d" :items="collection('JICS_RingMarry', 'R', true)" />

      <ItemList title="ジュエルアイドルチャレンジセット|～だいあ＆アンジュ～" color="#00c7da" :items="collection('JICS_Dia_Ange', 'SR')" />
      <ItemList title="" color="#feab0d" :items="collection('JICS_Dia_Ange', 'R', true)" />
    </template>

    <template #col3>
      <ItemList title="キラッとスペシャル！|ファイル＆コーデDXセット" color="#00c7da" :items="collection('FileCoordDXSet1', 'SR')" />
    </template>

    <template #col4>
      <ItemList title="キラッとスペシャル！|ファイル＆コーデDXセット2" color="#00c7da" :items="collection('FileCoordDXSet2', 'SR')" />
      <ItemList title="だいあとアンジュ|ジュエル＆コーデセット" color="#00c7da" :items="collection('Dia_Ange_JewelCoordSet', 'SR')" />
      <Status :date="date" :items="items" />
    </template>

    <template #col5>
    </template>

  </ItemPage>
</template>


<style lang="scss" scoped>
  @import '~@/stylesheets/common';

  // PC View: ステータスの表示位置を調整
  .Page ::v-deep .Status {
    // PC View のとき position: absolute になっている (see: ItemPage.vue)
    bottom: 0;
    // right: 0;
  }

  // PC View: ステータス表示を置く空間を確保
  @include iroha-vw-range($from: strip-unit($device-width--pc), $also-apply: print) {
    .Page ::v-deep .Page__body {
      padding-bottom: $size-unit * 20;
    }
  }
</style>
